export const dataTestId = {
  title: 'data-test-id-title',
  description: 'data-test-id-description',
} as const
